import React from 'react'
import styled from 'styled-components'

import LazyImage from '../../../components/display/LazyImage'

import { illustrationImage as defaultImage } from './content'

const IllustrationFigure = styled.figure`
  width: 100%;
  height: 0;
  margin: 0;
  padding-top: 100%;
  position: relative;

  img,
  ${LazyImage} {
    height: 100%;
    width: 100%;
    object-fit: contain;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
`

type Props = {
  illustrationImage?: {
    medium: string
    large: string
  }
}

const StoriesIllustrationFigure = ({
  illustrationImage = defaultImage,
}: Props) => (
  <IllustrationFigure>
    <LazyImage
      alt="Stories illustration"
      data-src={illustrationImage.medium}
      data-srcset={`
              ${illustrationImage.medium} 600w,
              ${illustrationImage.large} 1200w,
            `}
    />
  </IllustrationFigure>
)

export default StoriesIllustrationFigure
